export default "__VITE_ASSET__TrMxeQUO__"